import type { fabric } from 'fabric';
import type { FabricEditor } from 'modules/fabric-editor';
import { getPlaceholderData } from 'modules/manager/domain/placeholder';
import { resolvePlaceholder, type ResolverContext } from 'modules/manager/domain/placeholder';

export async function substitutePlaceholders(editor: FabricEditor, ctx: ResolverContext): Promise<void> {
  const facade = editor.placeholders;
  if (!facade) return;
  const targets = editor.canvas.getObjects().filter((o): o is fabric.Group => facade.isPlaceholder(o));
  const tasks: Promise<void>[] = [];
  for (const group of targets) {
    const data = getPlaceholderData(group);
    if (!data) continue;
    const value = resolvePlaceholder(data, ctx);
    if (!value) {
      editor.canvas.remove(group);
      continue;
    }
    tasks.push(facade.applyResolved(group, value));
  }
  await Promise.all(tasks);
  editor.canvas.requestRenderAll();
}
